import { render } from "./Accused.vue?vue&type=template&id=969d7eba"
import script from "./Accused.vue?vue&type=script&lang=js"
export * from "./Accused.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__